import { useTranslation, Trans } from '@mc/i18n'
import Link from 'components/Link'
import { GuestPassTermsLink } from '../GuestPassTermsLink'

export const RecipientLegalTextContent = () => {
  const { t } = useTranslation('@mc/next')

  return (
    <>
      <h2 className='mc-opacity--muted mc-text-h5 mc-mb-8'>
        {t('guestPassRecipient.hero.subtitle')}
      </h2>
      <p className='mc-opacity--hinted mc-text-x-small mc-mb-8'>
        <Trans i18nKey='guestPassRecipient.hero.offerTerms' ns='@mc/next'>
          <GuestPassTermsLink className='mc-text--capitalize' />
          <Link className='mc-text--link' href='#faq' isBasic />
        </Trans>
      </p>
    </>
  )
}
